var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoodsDayImageActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.615,
    fill: "#B8CCFD",
    stroke: "#5270BD",
    strokeWidth: 2.77
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2112 12.353C22.7526 12.8944 22.7526 13.7722 22.2112 14.3136L15.9175 20.6073C15.6575 20.8673 15.3049 21.0133 14.9372 21.0133C14.5695 21.0133 14.2169 20.8673 13.9569 20.6073L11.0198 17.6702C10.4784 17.1288 10.4784 16.251 11.0198 15.7096C11.5612 15.1682 12.439 15.1682 12.9804 15.7096L14.9372 17.6664L20.2506 12.353C20.792 11.8115 21.6698 11.8115 22.2112 12.353Z",
    fill: "#5270BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodsDayImageActive);
export default __webpack_public_path__ + "static/media/moodsDayImageActive.fb6f22c412b29e1164cfd55cbcc8f289.svg";
export { ForwardRef as ReactComponent };